/**
 * Mobile Scroll Handler for You Good Clothing
 * Handles hide-on-scroll header behavior for better mobile UX
 */

if (window.innerWidth < 750) {
  let lastScrollTop = 0;
  let scrollThreshold = 10; // Minimum scroll distance to trigger
  let isScrolling;

  window.addEventListener('scroll', function() {
    // Clear timeout for debouncing
    window.clearTimeout(isScrolling);

    isScrolling = setTimeout(function() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      // Only trigger after scrolling past threshold
      if (Math.abs(currentScroll - lastScrollTop) < scrollThreshold) {
        return;
      }

      if (currentScroll > lastScrollTop && currentScroll > 100) {
        // Scrolling down & past 100px
        document.body.classList.add('scrolling-down');
        document.body.classList.remove('scrolling-up');
      } else if (currentScroll < lastScrollTop) {
        // Scrolling up
        document.body.classList.add('scrolling-up');
        document.body.classList.remove('scrolling-down');
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }, 50); // Debounce delay
  }, { passive: true });
}
